import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserPlus, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await register(form.name, form.email, form.password);
      navigate("/", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] container-x flex items-center justify-center py-16">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-gold mb-8">
          <ArrowLeft className="w-4 h-4" /> Anasayfa
        </Link>
        <span className="section-eyebrow">Kayıt</span>
        <h1 className="font-display text-4xl md:text-5xl mt-3 mb-2">Aramıza <span className="italic gold-gradient-text">katılın</span>.</h1>
        <p className="text-white/60 mb-8">Hesabınızı oluşturun ve programlara erişin.</p>

        <form onSubmit={submit} data-testid="register-form" className="space-y-5">
          {error && <div className="bg-red-950/40 border border-red-800 text-red-200 p-3 text-sm">{error}</div>}
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-white/60 mb-2 inline-block">Ad Soyad</span>
            <input data-testid="register-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input-style" />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-white/60 mb-2 inline-block">E-posta</span>
            <input data-testid="register-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-style" />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-widest text-white/60 mb-2 inline-block">Şifre</span>
            <input data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="input-style" />
            <span className="text-xs text-white/50 mt-1 inline-block">En az 6 karakter.</span>
          </label>
          <button data-testid="register-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60">
            {loading ? "Kayıt olunuyor..." : "Hesap Oluştur"} <UserPlus className="w-4 h-4" />
          </button>
        </form>

        <div className="mt-8 text-center text-sm text-white/60">
          Zaten hesabınız var mı?{" "}
          <Link to="/giris" className="text-gold hover:underline">Giriş yapın</Link>
        </div>
      </div>

      <style>{`
        .input-style { width: 100%; background: #0F0F14; border: 1px solid rgba(255,255,255,0.08); padding: 0.75rem 1rem; color: white; font-family: 'Outfit', sans-serif; outline: none; transition: border-color 0.2s ease; }
        .input-style:focus { border-color: rgba(212,175,55,0.6); }
      `}</style>
    </div>
  );
}
